import Spline from '@splinetool/react-spline';

const AudUI = () => {
  return (
    <Spline className="aud-spline" scene="https://prod.spline.design/DQ3IVktoR7mC0Djn/scene.splinecode" />
  );
}

export default AudUI;